








































































































import { Component, Vue } from "vue-property-decorator";
import { getProvince, getRegion, getEdit, getUserInfo } from "@/req/user";
import selectDate from "./selectDate.vue";
import inputRules from "./inputRules.vue";
import Model from "./Model/amendModel.vue";
import avator from "./Model/avator.vue";
@Component({
  components: {
    selectDate,
    inputRules,
    Model,
    avator,
  },
})
export default class Home extends Vue {
  public information = JSON.parse(JSON.stringify(this.$store.state.user.info));
  public provinceList = []; // 获取省份
  public cityList = []; // 获取市级
  public showAccount = false;
  public showNickName = false;
  public leaveState = false;
  public editData: any = [];
  public leave: any = "";
  public created() {
    this.getProvince();
    if (this.information.province != "") {
      this.handleCity(this.information.province);
    }
  }
  // 获取省份
  public async getProvince() {
    const res = await getProvince({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code === 200) {
      this.provinceList = res.data.provinceData;
    }
  }
  // 获取市级
  public async handleCity(val) {
    const res = await getRegion({
      token: this.$fn.cookies.getToken("token"),
      id: val,
    });
    if (res.code === 200) {
      this.cityList = res.data.cityData;
      this.information.city = res.data.cityData[0].id;
    }
  }
  public submit() {
    if (this.showAccount || this.showNickName) {
      return false;
    }
    if (
      JSON.stringify(this.information) ==
      JSON.stringify(this.$store.state.user.info)
    ) {
      this.$router.push("/user");
      return this.$Message.success("修改成功");
    }
    this.leave = "";
    this.getEdit();
  }
  public prev() {
    this.$router.back();
  }
  public clearBlank() {
    this.information.introduction = this.information.introduction.replace(
      /[<>&]/g,
      ""
    );
    this.information.introduction = this.$fn.filter(this.information.introduction);
  }
  public amend(val) {
    if (val == 2) {
      this.$Modal.error({
        content: "盒子号30天修改1次"
      })
    } else {
      this.showAccount = !this.showAccount;
    }
  }
  public accountChange(val) {
    this.information.account = val;
    this.showAccount = !this.showAccount;
  }
  public nickNameChange(val) {
    this.information.nick_name = val;
    this.showNickName = !this.showNickName;
  }
  public selectDate(val) {
    this.information.birthday_time = val;
  }
  public beforeRouteLeave(to, from, next) {
    if (
      !this.leaveState &&
      JSON.stringify(this.information) !=
        JSON.stringify(this.$store.state.user.info)
    ) {
      const $Model: any = this.$refs.Model;
      $Model.show(to);
      this.leave = to;
      next(this.leaveState);
    } else {
      document.body.style.overflow = "visible";
      next();
    }
  }
  public async getEdit() {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      account: this.information.account,
      nick_name: this.information.nick_name,
      sex: this.information.sex,
      birthday_time: this.information.birthday_time,
      province: this.information.province,
      city: this.information.city,
      introduction: this.information.introduction,
      head_type: this.editData[0],
      img_id: this.editData[0] === 0 ? this.editData[1].id : "",
      head_file: this.editData[0] === 1 ? this.editData[1] : "",
    };
    if (this.$store.state.user.info.account == this.information.account) {
      this.$delete(obj, "account");
    }
    const res = await getEdit(obj);
    if (res.code == 200) {
      this.$Message.success(res.msg);
      this.getUserInfo();
      this.leaveState = true;
      if (this.leave == "") {
        this.$router.push("/user");
      } else {
        this.$router.push(this.leave.path);
      }
    } else {
      this.$Modal.error({
        title: "请求错误",
        content: res.msg,
      });
    }
  }
  public async avatorChange() {
    const $avator: any = this.$refs.avator;
    $avator.show();
  }
  /* public avatorAmend() {
    this.information.head_img = this.$store.state.user.info.head_img;
  } */
  public submitAvator(e) {
    if (e[0] === 0) {
      this.information.head_img = e[1].img;
    } else if (e[0] === 1) {
      this.information.head_img = e[1];
    }
    this.editData = e;
  }
  // 更换头像
  public async getUserInfo() {
    const res = await getUserInfo({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code === 200) {
      this.$store.dispatch("user/authInfo", res.data.userinfo);
    }
  }
}
